module.exports = __webpack_public_path__ + "img/icon_comment_2.385d10df.png";